import { render } from "./TicketTemplateChangeMulti.vue?vue&type=template&id=27b10311&scoped=true"
import script from "./TicketTemplateChangeMulti.vue?vue&type=script&lang=js"
export * from "./TicketTemplateChangeMulti.vue?vue&type=script&lang=js"

import "./TicketTemplateChangeMulti.vue?vue&type=style&index=0&id=27b10311&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b10311"]])

export default __exports__